import appmixer from '../../plugins/appmixer';
import QueryUtils from '../query';

export default {
    getSSOConfig() {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users/sso/config`,
            method: 'GET'
        });
    },
    getSSOAuthUrl(redirectUri) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users/sso/redirect`,
            method: 'POST',
            data: { redirectUri }
        });
    },

    authenticateUser(username, password) {
        return appmixer.api.authenticateUser(username, password);
    },
    authenticateSSOUser(redirectUri, code) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/user/sso/auth`,
            method: 'POST',
            data: { redirectUri, code }
        });
    },
    queryAuthUser() {
        return appmixer.api.getUser();
    },

    queryUser(userId) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users/${userId}`,
            method: 'GET'
        });
    },

    queryUsers(query = {}) {
        query = QueryUtils.processQuery(query);
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users`,
            method: 'GET',
            params: query
        });
    },

    queryUsersCount(query = {}) {
        query = QueryUtils.processQuery(query);
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users/count`,
            method: 'GET',
            params: query
        });
    },

    updateUser(userId, payload) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/users/${userId}`,
            method: 'PUT',
            data: payload
        });
    },

    addUser(payload) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/user`,
            method: 'POST',
            data: payload
        });
    },

    removeUser(userId) {
        const { api } = appmixer;
        const { baseUrl } = api;

        return api.request({
            url: `${baseUrl}/users/${userId}`,
            method: 'DELETE'
        });
    },

    removeStatus(userId, ticket) {
        const { api } = appmixer;
        const { baseUrl } = api;

        return api.request({
            url: `${baseUrl}/users/${userId}/delete-status/${ticket}`,
            method: 'GET'
        });
    }
};
